import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "../../../components/layout/Sheet";
import { Button, LangToggler, ThemeToggler } from "../../../components/ui";
import BreadCrumb from "../../../components/ui/Breadcrumb/BreadCrumb";
import CommonSidebar from "../components/CommonSidebar";
import Notifications from "./Notifications";
import UserMenu from "./UserMenu";
import { useStore } from "../../../store/store";
import { PermissionGuard } from "@/components/PermissionGuard";

const Navbar = () => {
  const setSidebarToggle = useStore((state) => state.setSidebarToggle);
  const isSidebarToggle = useStore((state) => state.isSidebarToggle);

  return (
    <header className="text-gray py-2 px-4 text-foreground">
      <section className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="xs"
            className="shrink-0 p-0"
            onClick={() => setSidebarToggle(!isSidebarToggle)}
            id="toggle-navigation-menu-button"
          >
            <Menu className="icon" />
            <span className="sr-only">Toggle navigation menu</span>
          </Button>
          <Sheet>
            <SheetTrigger asChild></SheetTrigger>
            <SheetContent side="left" className="px-0 py-3 sidebar">
              <CommonSidebar />
            </SheetContent>
          </Sheet>
          <BreadCrumb />
        </div>
        <div className="flex items-center gap-4">
          <PermissionGuard permissions={["can-view-notifications"]}>
            <Notifications />
          </PermissionGuard>
          <LangToggler />
          <ThemeToggler />
          <UserMenu />
        </div>
      </section>
    </header>
  );
};

export default Navbar;
